export enum BidLineItemType {
  Bid = "Bid",
  Option = "Option",
}
